<template>
	<div class="pa-3 limitWidth1000">
	<h1>Chat Debug Tool</h1>

		<PatientPicker
			v-model="patientUserId"
			:label="$t('nutriyou.patient')"
			:IsAdmin="true"
			@change="LoadChat"
		></PatientPicker>

		<v-skeleton-loader
			type="list-item@10"
			v-if="loadingMessages"
		></v-skeleton-loader>
		<div v-else>
			<div
				v-for="message in messages"
				:key="message.MessageId"
				class="rounded mb-2 py-2 poppins-regular"
				:class="
					message.AuthorId === patientDetails.UserId
						? 'text-right yellow lighten-3 ml-10 pl-2 pr-5'
						: 'text-left green lighten-4 mr-10 pl-5 pr-2'
				"
			>
				<div class="poppins-medium">
					{{
						message.AuthorId === patientDetails.UserId
							? patientDetails.ApplicationUser.DisplayName
							: patientDetails.DefaultNutritionist.DisplayName
					}}
				</div>
				<div class="py-2" v-if="message.Body">
					{{ message.Body }}
				</div>
				<div v-if="message.ParsedAttributes && Object.keys(message.ParsedAttributes).length > 0">
					<span class="poppins-semibold">{{message.ParsedAttributes.MessageType}}</span>
					<div v-if="message.ParsedAttributes.MessageType === 'SendFile'">
<!--						{{message.ParsedAttributes}}-->
<a :href="message.ParsedAttributes.FileUrl" target="_blank">Download</a>
						<v-img v-if="message.ParsedAttributes.FilePreviewUrl" max-height="230" contain :src="message.ParsedAttributes.FilePreviewUrl"></v-img>

					</div>

				</div>
<!--				<div v-if="message.Attributes !== '{}'">-->
<!--					<div v-if="JSON.parse(message.Attributes) === 'SendFile'">-->
<!--						{{ message.Attributes.MessageType }}-->
<!--					</div>-->
<!--				</div>-->
				<div style="font-size: 0.6em">
					{{ message.DateCreated | formatLocalDateTime }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import PatientPicker from "@/views/Nutritionists/components/PatientPicker.vue";
import CrudClient from "@/services/CrudClient";

export default {
	name: "ChatViewer",
	components: { PatientPicker },
	data() {
		return {
			patientUserId: null,
			loadingMessages: false,
			patientDetails: null,
			messages: []
		};
	},
	created() {
		this.PatientsService = new CrudClient("Patients");
		this.chatService = new CrudClient("Chat");
	},
	methods: {
		async LoadChat() {
			if (this.patientUserId === null) {
				this.messages = [];
				this.patientDetails = null;
				return;
			}
			await this.FetchMessages();
		},

		async FetchMessages() {
			// avoid simultaneous fetching
			if (this.loadingMessages) return;

			this.loadingMessages = true;

			try {
				this.patientDetails = await this.PatientsService.GetSelectedFields(
					this.patientUserId,
					"UserId,DefaultNutritionistUserId"
				);

				// TODO: fetching all items for now, enable pagination on the server side
				const incomingData = await this.chatService.Get(
					null,
					`Messages/${this.patientUserId}/${this.patientDetails.DefaultNutritionistUserId}`
				);

				this.messages = incomingData.map(message => ({
					...message,
					ParsedAttributes: message.Attributes ? JSON.parse(message.Attributes) : null
				}));
			} catch (err) {
				this.snackError({
					Text: this.$t("common.error.cannotLoadMessages")
				});
				this.$captureError(err);
			} finally {
				this.loadingMessages = false;
			}
		}
	}
};
</script>

<style scoped lang="scss"></style>
